var map = {
	"./blunt-times.jpeg": 5959,
	"./dhabkar-article.jpeg": 2767,
	"./dhabkar-e-passport.jpeg": 8615,
	"./green-card-eagle-act.jpeg": 6869,
	"./green-card.jpeg": 1329,
	"./gujarat-mitra.jpeg": 625,
	"./gujarati-mitra-canada.jpeg": 6153,
	"./lok-tej-article.jpeg": 5940,
	"./lok-tej-digital-kranti-article.jpeg": 4263,
	"./lok-tej-e-passport-article.jpeg": 2341,
	"./lok-tej-french-article.jpeg": 1261,
	"./samruddhi-article.jpeg": 7693,
	"./samruddhi-e-passport.jpeg": 9393,
	"./sardar-dham-article.jpeg": 5518,
	"./tax-val-article.jpeg": 1291,
	"./the-blunt-times-gst-article.jpeg": 9965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;